import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { observable, computed, transaction } from 'mobx'
import { HelpBlock, FormGroup, Tooltip, OverlayTrigger, Button } from 'react-bootstrap'
import views from '../../routeconfig'
import * as defaultConst from '../../constants/default_constants'

const suggestionStyle = {
  position: 'absolute',
  left: 0,
  top: '2em',
  zIndex: 1000
}

@observer
class SelectMultipleValsInput extends React.Component {
  static propTypes = {
    attr: PropTypes.string.isRequired,
    addNew: PropTypes.bool,
    errors: PropTypes.object,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    optionsattr: PropTypes.string,
    optionsrecord: PropTypes.object.isRequired,
    record: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    validationSuccess: PropTypes.bool
  }

  _getUniqueOpts () {
    const { record, attr, optionsrecord, optionsattr } = this.props
    const data = record.get(attr) || []
    const val = this.inputval
    return val ? optionsrecord.get(optionsattr || attr).filter((i) => {
      const matchVal = i.text.toLowerCase().indexOf(val.toLowerCase()) !== -1
      return matchVal && (
        !data.find((dato) => i.value === dato.enum_value) // not yet selected
      )
    }) : []
  }

  @observable inputval = ''
  @computed get availableOptions () {
    return this._getUniqueOpts()
  }

  renderChip (data, idx, options) {
    const opt = options.find((i) => {
      return i.value === data.enum_value.toString()
    })
    return (
      <div key={idx} className="btn btn-default btn-xs add-rmargin">
        <span className="rmargin">{(opt && opt.text) || ''} </span>
        {
          this.props.disabled ? null : (
            <span className="glyphicon glyphicon-remove" onClick={
              () => this.onDelete(data.enum_value)
            }></span>
          )
        }
      </div>
    )
  }

  onDelete (delvalue) {
    const { record, attr, store } = this.props
    const value = record.get(attr) || []
    value.remove(value.find((i) => i.enum_value === delvalue))
    const v = store.cv.validators._global
    v && store.cv._validateField('_global', store.cv.record, v)
  }

  handleUpdateInput (evt) {
    this.inputval = evt.target.value
  }

  handleSelected (selected) {
    const { record, attr, onChange, optionsrecord, optionsattr, store } = this.props
    const options = optionsrecord.get(optionsattr || attr)
    const value = record.get(attr)
    transaction(() => {
      if (value) {
        value.push({ enum_value: selected.value })
      } else {
        onChange(attr, [{ enum_value: selected.value }])
      }
      const v = store.cv.validators._global
      v && store.cv._validateField('_global', store.cv.record, v)
      this.inputval = ''
    })
  }

  handleAddNew (words) {
    const { store, record, optionsrecord, optionsattr, attr } = this.props
    const options = optionsrecord.get(optionsattr)
    const value = record.get(attr)
    const valueValues = value.map(j => j.enum_value)

    // new words
    const newWordsUnique = []
    words && words.length > 0 && words.replace(/\t|;/g, ',')
      .replace(/^,+|,+$/g, '')
      .split(',')
      .map(i => i.trim())
      .filter(i => i.length > 0)
      .map(i => {
        const slug = store.toSlug(i)
        if (!newWordsUnique.find(j => j.value === slug)) {
          newWordsUnique.push({
            text: i.toString(),
            value: slug
          })
        }
      })

    newWordsUnique.filter(i => !valueValues.includes(i.value))
      .map(i => {
      // save new enum
        if (!options.find(j => j.value === i.value)) {
          const newEnum = {
            created_at: new Date(),
            id: null,
            lang: defaultConst.DEFAULT_LANG,
            parent: optionsattr,
            text: i.text,
            value: i.value
          }
          store.requester.call('/enums', 'post', [newEnum])
            .catch(store.onRequesterError.bind(store))
            .then(_ => {
            // after save
              optionsrecord.get(optionsattr).push(newEnum)
              store.markDirty(optionsattr)
              store.addMessage(
                '"' + i.text.concat('" ') +
              store.__('has been saved to the Enums.'),
                'info', '5000')
            })
        }

        // new value
        value.push({ enum_value: i.value })
      })

    // finaly clear input
    this.inputval = ''
  }

  render () {
    const { record, attr, onChange, optionsrecord, optionsattr, errors, label, validationSuccess, disabled, store, addNew } = this.props
    const errorText = errors ? errors.get(attr) : undefined
    const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
    const value = record.get(attr) || []
    const options = optionsrecord.get(optionsattr || attr)
    if (!options || options.length === 0) {
      return null
    }
    const chips = value && value.map((val, idx) => {
      return this.renderChip(val, idx, options)
    })
    const toolTip = optionsattr && options && (
      <Tooltip id={optionsattr}>Enum ID:&nbsp;
        <strong>{optionsattr}</strong>
      </Tooltip>
    )

    return (
      <FormGroup controlId={attr} validationState={validationState}>
        {label && <label className="control-label">{label}</label>}
        {label && optionsattr && options &&
          <OverlayTrigger
            onClick={() => store.router.goTo(views.enum_edit, {}, store, { _autoscroll: optionsattr })}
            placement='right' overlay={toolTip}>
            <span className='glyphicon glyphicon-list-alt cursor-pointer' style={{ fontSize: '0.75em', marginLeft: '0.7em' }}></span>
          </OverlayTrigger>
        }
        <div>
          {chips}
        </div>
        {disabled
          ? null
          : (<div style={{ position: 'relative' }}>
            <input className="form-control" type="text" value={this.inputval}
              onChange={this.handleUpdateInput.bind(this)} />
            {this.availableOptions.length
              ? (<select style={suggestionStyle} multiple={true}>
                {this.availableOptions.map((i, idx) => (
                  <option key={idx} value={i.value} onClick={(e) =>
                    this.handleSelected(i)
                  }>{i.text}</option>
                ))}
              </select>)
              : (addNew && this.inputval && this.inputval.length >= 2 &&
                <div>
                  <Button bsSize='xs' bsStyle='success' onClick={_ => this.handleAddNew(this.inputval)}>
                    <em className='glyphicon glyphicon-plus-sign'></em>&nbsp;
                    {store.__('Add new')}
                  </Button>&nbsp;
                  <em style={{ float: 'right', fontSize: '85%' }}>({store.__('Use a comma to separate multiple words.')})</em>
                </div>)
            }
          </div>)
        }
        {errorText ? <HelpBlock>{errorText}</HelpBlock> : null}
      </FormGroup>
    )
  }
}
export default SelectMultipleValsInput
